import { jsxs as u, jsx as r } from "react/jsx-runtime";
import oe from "classnames";
import { noop as ge } from "lodash/fp";
import { useRef as O, useState as _, useEffect as ve, useCallback as m } from "react";
import t from "./index.es734.js";
import { validateFileFormat as ae, downloadFile as ye } from "./index.es735.js";
import { FileUploadItem as ie } from "./index.es736.js";
import { MetricUploadIcon as F } from "./index.es418.js";
import { Divider as $e } from "./index.es18.js";
import { onKeyDownEnter as le } from "./index.es500.js";
import { LabeledField as se } from "./index.es494.js";
import { FlexContainer as Y } from "./index.es525.js";
import { Heading as De } from "./index.es489.js";
import { BodyText as R } from "./index.es487.js";
import { HelpButton as be } from "./index.es8.js";
const Ne = "file-upload", Ke = ({
  variant: C = "field",
  files: ce = [],
  required: M,
  isError: S,
  feedback: x,
  formats: h,
  label: de,
  disabled: n,
  testId: v = Ne,
  maxFiles: i = 1,
  maxSize: I,
  fileValidation: j,
  asterix: V,
  setFiles: y,
  infoTooltip: G,
  onFailedUpload: g = ge,
  additionalHelp: J,
  description: Q,
  limitationsText: k,
  templateFileUrl: w,
  helpButtonProps: X
}) => {
  const T = O(null), [c, B] = _(ce), $ = O(void 0), [P, H] = _(!1), [z, d] = _(""), K = O(`file-upload-${Math.random().toString(36).substr(2, 9)}`), Z = `${K.current}-input`, A = `${K.current}-status`, D = `${K.current}-dropzone`, ue = oe(t["upload-area"], {
    [t.disabled]: n
  }), q = oe(t.container, {
    [t.multi]: i > 1,
    [t.focusMode]: P,
    [t.isError]: S,
    [t.disabled]: n,
    [t.hasFiles]: c == null ? void 0 : c.length,
    [t.fullSize]: C === "container",
    [t.fullSizeFocused]: C === "container" && P,
    [t.fullSizeHasFiles]: C === "container" && (c == null ? void 0 : c.length)
  });
  ve(() => {
    if (z) {
      const e = setTimeout(() => {
        d("");
      }, 5e3);
      return () => clearTimeout(e);
    }
  }, [z]);
  const fe = `Accepted file formats: ${h.join(", ")}`, pe = i > 1 ? `You can upload up to ${i} files` : "You can upload 1 file", me = I ? `Maximum file size: ${Math.round(I / 1024 / 1024)} MB` : "", L = m(
    (e) => {
      B((o) => {
        if (o.length + e.length > i) {
          const a = "Maximum files has been reached";
          return d(a), g([a]), o;
        }
        const [l, s] = e.reduce(
          ([a, p], E) => (j && !j(E.file) ? p.push(`${E.fileName} has failed file validation`) : I && E.file.size > I ? p.push(
            `${E.fileName} has exceeded the maximum file size`
          ) : a.push(E), [a, p]),
          [[], []]
        );
        s.length > 0 && (d(s.join(". ")), g(s));
        const f = [...o, ...l];
        return l.length > 0 && d(
          `Successfully added ${l.length} file${l.length !== 1 ? "s" : ""}`
        ), y(f), f;
      });
    },
    [i, g, y, j, I]
  ), W = m(
    (e) => {
      B((o) => {
        const l = o.filter((s) => s.fileName !== e);
        return y(l), d(`Removed file: ${e}`), l;
      });
    },
    [y]
  ), U = m(
    (e) => {
      B(e), y(e), e.length > 0 ? d(`Replaced with file: ${e[0].fileName}`) : d("All files removed");
    },
    [y]
  ), b = m(() => {
    var e;
    n || (e = T.current) == null || e.click();
  }, [n]), ee = m(
    (e) => {
      const o = e.target.files;
      if (o && o.length > 0) {
        const s = Array.from(o).filter((f) => {
          const a = ae(f, h);
          if (!a) {
            const p = `${f.name} has failed to upload, format not supported`;
            d(p), g([p]);
          }
          return a;
        }).map((f) => ({
          fileName: f.name,
          fileUrl: "",
          isError: !1,
          file: f
        }));
        i === 1 ? U(s) : L(s);
      }
    },
    [L, h, i, g, U]
  ), N = (e) => {
    H(!0), e.preventDefault(), e.stopPropagation(), e.type === "dragenter" && d("File is hovering over the drop zone"), $.current = setTimeout(() => {
      $.current && clearTimeout($.current), H(!1);
    }, 4e3);
  }, re = m(
    async (e) => {
      if (e.preventDefault(), e.stopPropagation(), $.current && (clearTimeout($.current), $.current = void 0), H(!1), e.dataTransfer.files && e.dataTransfer.files[0]) {
        const o = Array.from(e.dataTransfer.files), l = [], s = o.filter((a) => {
          const p = ae(a, h);
          return p || l.push(`${a.name} has failed to upload, format not supported`), p;
        });
        l.length && (d(l.join(". ")), g(l));
        const f = s.map((a) => ({
          fileName: a.name,
          fileUrl: "",
          isError: !1,
          file: a
        }));
        s.length > 0 && d(
          `${s.length} file${s.length !== 1 ? "s" : ""} dropped successfully`
        ), L(f), e.dataTransfer.clearData();
      }
    },
    [L, h, g]
  ), ne = m(
    (e, o) => {
      e.stopPropagation(), T.current && (T.current.value = ""), W(o);
    },
    [W]
  ), he = m(
    (e) => {
      e.stopPropagation(), w && (ye(w), d("Template file download started"));
    },
    [w]
  ), te = `${fe}. ${pe}. ${me}`;
  return C === "container" ? /* @__PURE__ */ u("div", { className: t.accessibilityWrapper, children: [
    /* @__PURE__ */ r("div", { "aria-live": "polite", className: "sr-only", id: A, children: z }),
    /* @__PURE__ */ u(
      "div",
      {
        onClick: b,
        onDrop: re,
        onDragEnter: N,
        onDragLeave: N,
        onDragOver: N,
        "data-testid": v,
        className: q,
        tabIndex: n ? -1 : 0,
        onKeyDown: (e) => le(e, b),
        role: "button",
        "aria-labelledby": D,
        "aria-describedby": `${D}-instructions ${A}`,
        "aria-disabled": n,
        children: [
          /* @__PURE__ */ r(
            "input",
            {
              ref: T,
              onChange: ee,
              accept: h.join(", "),
              "data-testid": `${v}-file-input`,
              type: "file",
              id: Z,
              "aria-label": `Upload ${i > 1 ? "files" : "a file"}`,
              style: { display: "none" },
              multiple: i > 1,
              disabled: n,
              "aria-required": M
            }
          ),
          c && c.length > 0 ? /* @__PURE__ */ r("div", { className: t.containerFilesArea, children: /* @__PURE__ */ r(
            se,
            {
              additionalHelp: J,
              feedback: n ? [] : x,
              disabled: n,
              required: M,
              testId: `${v}-label`,
              asterix: V,
              isError: S,
              infoTooltip: G,
              children: c.map(({ fileName: e, isError: o }) => /* @__PURE__ */ r(
                ie,
                {
                  isDisabled: n,
                  fileName: e,
                  isError: o,
                  onReplace: i === 1 ? b : void 0,
                  onRemoveFile: ne
                },
                e
              ))
            }
          ) }) : P ? /* @__PURE__ */ r(F, { size: "128px", "aria-hidden": "true" }) : /* @__PURE__ */ u(Y, { flexDirection: "column", gap: "16px", alignItems: "center", children: [
            /* @__PURE__ */ r(F, { size: "56px", "aria-hidden": "true" }),
            /* @__PURE__ */ u(De, { variant: "h5", children: [
              "Drag & drop, or",
              " ",
              /* @__PURE__ */ r("span", { className: t.coloredHeading, children: "browse" }),
              " your files"
            ] }),
            /* @__PURE__ */ r("div", { id: `${D}-instructions`, className: "sr-only", children: te }),
            /* @__PURE__ */ u(Y, { gap: "12px", alignItems: "center", children: [
              w && /* @__PURE__ */ r(
                "button",
                {
                  onClick: he,
                  "data-testid": "download-template",
                  className: t.downloadTemplateButton,
                  "aria-label": "Download template file",
                  children: /* @__PURE__ */ r(R, { children: "Download Template" })
                }
              ),
              w && k && /* @__PURE__ */ r($e, { isVertical: !0, "aria-hidden": "true" }),
              k && /* @__PURE__ */ u(Y, { gap: "4px", alignItems: "flex-end", children: [
                /* @__PURE__ */ r(R, { color: "gray", children: k }),
                X && /* @__PURE__ */ r(be, { ...X })
              ] })
            ] })
          ] })
        ]
      }
    )
  ] }) : /* @__PURE__ */ r(
    se,
    {
      label: de,
      additionalHelp: J,
      feedback: n ? [] : x,
      disabled: n,
      required: M,
      testId: `${v}-label`,
      asterix: V,
      isError: S,
      infoTooltip: G,
      children: /* @__PURE__ */ u("div", { className: t.accessibilityWrapper, children: [
        /* @__PURE__ */ r("div", { "aria-live": "polite", className: "sr-only", id: A, children: z }),
        /* @__PURE__ */ u(
          "div",
          {
            onDrop: re,
            onDragEnter: N,
            onDragLeave: N,
            onDragOver: N,
            "data-testid": v,
            className: q,
            tabIndex: n ? -1 : 0,
            role: "button",
            "aria-labelledby": D,
            "aria-describedby": `${D}-instructions ${A}`,
            "aria-disabled": n,
            onKeyDown: (e) => le(e, b),
            children: [
              /* @__PURE__ */ u("div", { className: ue, onClick: b, children: [
                /* @__PURE__ */ r(F, { "aria-hidden": "true" }),
                /* @__PURE__ */ u("div", { className: t.uploadButton, children: [
                  /* @__PURE__ */ u(R, { color: n ? "disabled" : "primary", children: [
                    "Drag & drop, or",
                    " ",
                    /* @__PURE__ */ r(R, { color: n ? "disabled" : "primary-brand", children: "browse" }),
                    " ",
                    "your files"
                  ] }),
                  Q && /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(R, { size: "small", color: "gray", children: Q }) }),
                  /* @__PURE__ */ r("div", { id: `${D}-instructions`, className: "sr-only", children: te }),
                  /* @__PURE__ */ r(
                    "input",
                    {
                      ref: T,
                      onChange: ee,
                      accept: h.join(", "),
                      "data-testid": `${v}-file-input`,
                      type: "file",
                      id: Z,
                      "aria-label": `Upload ${i > 1 ? "files" : "a file"}`,
                      style: { display: "none" },
                      multiple: i > 1,
                      disabled: n,
                      "aria-required": M
                    }
                  )
                ] })
              ] }),
              c && c.length > 0 && /* @__PURE__ */ r(
                "div",
                {
                  className: t["files-area"],
                  role: "list",
                  "aria-label": "Uploaded files",
                  children: c.map(({ fileName: e, isError: o }) => /* @__PURE__ */ r(
                    ie,
                    {
                      isDisabled: n,
                      fileName: e,
                      isError: o,
                      onReplace: i === 1 ? b : void 0,
                      onRemoveFile: ne
                    },
                    e
                  ))
                }
              )
            ]
          }
        )
      ] })
    }
  );
};
export {
  Ne as FILE_UPLOAD_DEFAULT_TESTID,
  Ke as FileUploadField
};
//# sourceMappingURL=index.es53.js.map
